import { VALIDATION_FIELDS } from '@interlayer/js/app/hooks/useValidationRules/constants';

export const BONUS_CODE_POPUP = 'bonus-code-popup';
export const ACCEPT_BONUS = 'ACCEPT_BONUS';
export const DECLINE_BONUS = 'DECLINE_BONUS';
export const STATUS_ISSUED_BONUS = 1;

export const VALIDATION_FIELDS_BONUS_CODE_POPUP = [VALIDATION_FIELDS.promoCode];
